// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-progress-bar-labled{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}.el-progress-bar__innerText{color:#303133}", ""]);
// Exports
module.exports = exports;
